import { UserInfo } from './business-base';
import { AirlineRating, AirlineStatus, DeviationTeamType, TransportationSystemType } from './business-enums';
import { UserContact } from './business-types';
import { EntityBase, EntityInfo, EnumInfo } from './platform-types';

export interface TransportType extends EntityInfo {
  dataTypeValue: TransportationSystemType;
  formIcon: string | null;
}

export interface AccommodationType extends EntityInfo {
  isForHolidayTrip: boolean;
  isForTravelRequest: boolean;
  formIcon: string | null;
}

export interface Country extends EntityInfo {
  isoCode2: string | null;
  isoCode3: string | null;
  formFlag: string | null;
}

export interface City extends EntityInfo {
  displayName: string;
  region: string | null;
  country: Country;
}

export interface Airline extends EntityInfo {
  code: string | null;
  rating: EnumInfo<AirlineRating> | null;
  status: EnumInfo<AirlineStatus> | null;
  comment: string | null;
}

export interface ApprovalLevel extends EntityInfo {
  description: string | null;
}

export interface OrganisationEntity extends EntityInfo {
  code: string | null;
}

export interface TravelType extends EntityInfo {
  // ...
}

export interface DeviationTeam extends EntityInfo {
  teamType: EnumInfo<DeviationTeamType>;
  teamLeader: UserInfo;
  members: UserInfo[];
  regionDirectors: DeviationTeamRegionDirector[];
}

export interface DeviationTeamRegionDirector extends EntityBase {
  region: string;
  director: UserContact;
}

export interface Site extends EntityInfo {
  address: string;
  country: Country;
  assetType: string;
  operation: string;
  latitude: number | null;
  longitude: number | null;
  icon: string;
}
